import { render, staticRenderFns } from "./OrticFilterSelect.vue?vue&type=template&id=42bd9b74&"
import script from "./OrticFilterSelect.vue?vue&type=script&lang=js&"
export * from "./OrticFilterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports